export default __webpack_public_path__ + "static/media/caroline.ba587834.jpg";